<div class="relative bg-white overflow-hidden">
  <div class="mx-auto max-w-7xl relative px-4 sm:px-6 lg:px-0 z-10 sm:grid sm:grid-cols-2 sm:gap-6 md:grid-cols-3 md:gap-8">
    <div class="aspect-w-16 aspect-h-9 bg-fr-orange" *ngFor="let video of blok.videos">
      <app-video class="w-full h-full" [videoId]="video.videoId"></app-video>
    </div>
  </div>
</div>